import { VIEW_MODES } from '@wix/wix-vod-constants/common';
import { xor as xorGuids } from './utils/guid';
import _ from 'lodash';
export function createSDK(WixSDKOriginal) {
  const DEFAULT_LOCALE = 'en';
  const AVAILABLE_LOCALES = process.env.AVAILABLE_LOCALES || [DEFAULT_LOCALE];
  const DEVICE_TYPES = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop'
  };
  function invokeSafely(fn, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = null;
    }
    return function () {
      try {
        return fn.apply(this, arguments); // eslint-disable-line no-invalid-this
      } catch (ex) {
        return defaultValue;
      }
    };
  }
  function getRandomGuid4() {
    // generate fake guid starting on badabada
    /* eslint-disable */
    return 'badabada-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
  let newInstance;
  const isBusinessManager = !_.isEmpty(global.BusinessManagerAPI);
  if (WixSDKOriginal && !isBusinessManager) {
    WixSDKOriginal.addEventListener(WixSDKOriginal.Events.INSTANCE_CHANGED, function (event) {
      newInstance = event.instance;
    });
  }
  const SDK = WixSDKOriginal ? {
    ...WixSDKOriginal,
    addEventListener: _.get(WixSDKOriginal, 'addEventListener', _.noop),
    removeEventListener: WixSDKOriginal.removeEventListener || _.noop,
    closeWindow: WixSDKOriginal.closeWindow || _.noop,
    currentMember() {
      if (WixSDKOriginal.Utils.getViewMode() === VIEW_MODES.SITE) {
        return new Promise(WixSDKOriginal.currentMember);
      }
      return Promise.resolve(null);
    },
    getBoundingRectAndOffsets() {
      return new Promise(WixSDKOriginal.getBoundingRectAndOffsets);
    },
    getSiteUrl() {
      const viewMode = WixSDKOriginal.Utils.getViewMode();
      return new Promise(resolve => {
        if (viewMode === VIEW_MODES.STANDALONE || viewMode === VIEW_MODES.DASHBOARD) {
          return WixSDKOriginal.Dashboard.getSiteViewUrl(siteViewUrl => resolve(siteViewUrl.base));
        }
        WixSDKOriginal.Settings.getSiteInfo(siteInfo => resolve(siteInfo.baseUrl));
      });
    },
    getCurrentPageId() {
      return new Promise(WixSDKOriginal.getCurrentPageId);
    },
    getComponentInfo() {
      return new Promise(WixSDKOriginal.getComponentInfo);
    },
    Dashboard: {
      ...WixSDKOriginal.Dashboard,
      getEditorUrl() {
        const getEditorUrl = _.get(WixSDKOriginal, 'Dashboard.getEditorUrl');
        if (getEditorUrl) {
          return new Promise(getEditorUrl);
        }
        return Promise.resolve(null);
      }
    },
    Data: {
      ...WixSDKOriginal.Data,
      Public: {
        ..._.get(WixSDKOriginal, 'Data.Public', {}),
        get(key, options) {
          return new Promise(_.partial(WixSDKOriginal.Data.Public.get, key, options));
        },
        set(key, value, options) {
          return new Promise(_.partial(WixSDKOriginal.Data.Public.set, key, value, options));
        },
        remove(key, options) {
          return new Promise(_.partial(WixSDKOriginal.Data.Public.remove, key, options));
        }
      }
    },
    PubSub: {
      ...WixSDKOriginal.PubSub,
      subscribe: _.get(WixSDKOriginal, 'PubSub.subscribe', _.noop),
      unsubscribe: _.get(WixSDKOriginal, 'PubSub.unsubscribe', _.noop)
    },
    Settings: {
      ...WixSDKOriginal.Settings,
      setExternalId(id) {
        return new Promise((resolve, reject) => WixSDKOriginal.Settings.setExternalId(id, resolve, reject));
      },
      getSiteInfo() {
        const viewMode = WixSDKOriginal.Utils.getViewMode();
        if (viewMode === VIEW_MODES.STANDALONE || viewMode === VIEW_MODES.DASHBOARD) {
          return Promise.resolve({
            url: window.location.href
          });
        }
        return new Promise(WixSDKOriginal.Settings.getSiteInfo);
      },
      getDashboardAppUrl() {
        return new Promise(WixSDKOriginal.Settings.getDashboardAppUrl);
      }
    },
    Styles: {
      ...WixSDKOriginal.Styles,
      setWidgetChannel() {
        return _.noop();
      },
      setFontParam(key, value) {
        return new Promise(_.partial(WixSDKOriginal.Styles.setFontParam, key, {
          value
        }));
      },
      setBooleanParam(key, value) {
        return new Promise(_.partial(WixSDKOriginal.Styles.setBooleanParam, key, {
          value
        }));
      },
      setStyleParams(params) {
        return new Promise(_.partial(WixSDKOriginal.Styles.setStyleParams, params));
      }
    },
    Utils: {
      ...WixSDKOriginal.Utils,
      getCompId: _.get(WixSDKOriginal, 'Utils.getCompId', _.noop),
      getOrigCompId: _.get(WixSDKOriginal, 'Utils.getOrigCompId', _.noop),
      getDeviceType: _.get(WixSDKOriginal, 'Utils.getDeviceType', _.constant(DEVICE_TYPES.DESKTOP)),
      getBiToken: function getBiToken() {
        const biToken = WixSDKOriginal.Utils.getInstanceValue('biToken');
        return biToken || getRandomGuid4();
      },
      getLocale() {
        // I really don't know why do we need here try/catch, but I'll leave it as it was
        try {
          const originalGetLocale = _.get(WixSDKOriginal, 'Utils.getLocale', _.noop);
          const locale = originalGetLocale();
          if (!locale || locale.length > 2) {
            // prevent xss
            return DEFAULT_LOCALE;
          }
          return _.includes(AVAILABLE_LOCALES, locale) ? locale : DEFAULT_LOCALE;
        } catch (error) {
          return DEFAULT_LOCALE;
        }
      },
      getInstance() {
        if (newInstance) {
          return newInstance;
        }
        try {
          return location.search.match(/(?:\?|&)instance=([^&]+)/)[1];
        } catch (error) {
          return null;
        }
      },
      getInstanceId: function getInstanceId() {
        return SDK.Utils.getInstanceValue('instanceId') || getRandomGuid4();
      },
      getInstanceValue: invokeSafely(function (key) {
        // if biToken is missing for any reason, SDK.Utils.getBiToken will generate fake one
        if (key === 'biToken') {
          return this.getBiToken();
        }
        if (key === 'appDefId') {
          if (SDK.Utils.getViewMode() === VIEW_MODES.STANDALONE) {
            return '143314e1-0660-f409-9aa7-6ed544ff1957'; // APP_DEFINITION_ID for DEV STANDALONE
          }
        }

        const result = WixSDKOriginal.Utils.getInstanceValue(key);
        if (key === 'siteOwnerId' && !result) {
          return WixSDKOriginal.Utils.getInstanceValue('uid');
        }
        return result;
      }),
      getMetaSiteIdFromBiToken() {
        let biToken;
        let instanceId;
        try {
          biToken = this.getInstanceValue('biToken');
          instanceId = this.getInstanceId();
        } catch (error) {
          // do nothing
        }
        if (biToken && instanceId) {
          return xorGuids(biToken, instanceId);
        }
      },
      getMetaSiteId() {
        const metaSiteId = this.getMetaSiteIdFromBiToken();
        if (metaSiteId) {
          return Promise.resolve(metaSiteId);
        }
        const viewMode = SDK.Utils.getViewMode();
        if (viewMode === VIEW_MODES.STANDALONE) {
          return Promise.reject('Unable to get metaSiteId in standalone view mode');
        }
        if (viewMode === VIEW_MODES.EDITOR) {
          return SDK.Settings.getDashboardAppUrl().then(url => url.match(/\/sites\/([^/]+)/)[1]);
        }
        return SDK.Dashboard.getEditorUrl().then(url => url.match(/metaSiteId=([^&]+)/)[1]);
      },
      getUid() {
        try {
          return WixSDKOriginal.Utils.getUid();
        } catch (error) {}
        try {
          return document.cookie.match(/wixClient=([^;]+)/)[1].split('|')[6];
        } catch (error) {}
        return null;
      },
      getViewMode: _.get(WixSDKOriginal, 'Utils.getViewMode', _.noop)
    }
  } : null;
  return SDK;
}
export const WixSDK = createSDK(global.Wix);
//# sourceMappingURL=wix-sdk.js.map